var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.label,"prop":_vm.prop,"rules":_vm.rules}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }